import "regenerator-runtime/runtime";
import '../js/application'
import '../scss/main.scss'
